export default "__VITE_ASSET__3p3EcO_W__"